export enum PASSWORD_GENEREATE_TYPE {
  AUTO = 'auto',
  CUTSOM = 'custom'
}
